import { useLazyQuery } from '@apollo/client';
import useEnableFastifyApi from './useEnableFastifyApi';
import { FLIGHTS_SEARCH_RETURN } from '../queries';
import restRequest from './restClient';
import useAsyncCall from './useAsyncCall';

function toGraphqlShape(bffResponse) {
  return { returnFlightsSearch: bffResponse };
}

export default function useFlightSearchReturn(options) {
  const enableFastifyApi = useEnableFastifyApi();

  const graphqlResult = useLazyQuery(FLIGHTS_SEARCH_RETURN, options);
  const [restExecute, restState] = useAsyncCall(
    ({ variables } = {}) =>
      restRequest({
        method: 'POST',
        path: '/air-api/v1/flights/return-search',
        body: variables,
      }).then(toGraphqlShape),
    options,
  );

  if (enableFastifyApi) {
    return [restExecute, restState];
  }
  return graphqlResult;
}
